export default {"src":"/_next/static/media/clock_gray.8e2598c2.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};